<template>
	<div>
		<el-table :data="dataList" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" style="width: 100%">
			<el-table-column prop="createTime" label="时间" width="160"></el-table-column>
			<el-table-column prop="createUsrCompany" label="执行方"></el-table-column>
			<el-table-column prop="createName" label="执行人" width="120"></el-table-column>
			<el-table-column prop="operNotes" label="事件"></el-table-column>
			<el-table-column prop="remark" label="批注"></el-table-column>
		</el-table>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dataList: [],
		};
	},
	mounted() {
		this.getAuditLogList();
	},
	methods: {
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 获取审核日志
		getAuditLogList() {
			const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
			if (claimId) {
				let self = this;
				self.$request.post("getAuditLogList", false, { id: claimId }, function (r) {
					if (r.code == "0") {
						self.dataList = r.data;
					} else {
						self.$message.error(r.msg);
					}
				});
			}
		},
	},
};
</script>
